export const engagementCampaignsCampaignOccurrencesAppGroupId =
  "/engagement/campaigns/campaign_occurrences/:app_group_id";
